module.exports = __webpack_public_path__ + "img/grade-halo.38b23483.png";